// homeUtils.js
'use strict';
import {
  BROWSE_FOLLOWING_CATEGORIES,
  BROWSE_EXPLORE_CATEGORIES,
  HOME_LIVESTREAM_CATEGORIES,
  HOME_VIDEO_CATEGORIES,
} from '../RemoteConfigKeys.js';
import { removeLangFromPath } from './langPath.js';

export const HOME_PAGE_CONFIG = {
  video: {
    paths: ['/video'],
    categoriesRemoteConfigKey: HOME_VIDEO_CATEGORIES,
    shouldUseRetainedEvents: true,
    // SEO config
    titleKey: 'seo_video_title',
    descriptionKey: 'seo_video_description',
    keywordsKey: 'seo_video_keywords',
    jsonLdType: 'ItemList',
  },
  home: {
    paths: ['/'],
    categoriesRemoteConfigKey: BROWSE_EXPLORE_CATEGORIES,
    tabsComponent: 'BrowseTab',
    shouldUseRetainedEvents: true,
    // SEO config
    titleKey: 'seo-explore-title',
    descriptionKey: 'seo-explore-description',
    keywordsKey: 'seo-explore-keywords',
    jsonLdType: 'WebSite',
    shouldAppendBrandingSuffix: false,
  },
  following: {
    paths: ['/following'],
    categoriesRemoteConfigKey: BROWSE_FOLLOWING_CATEGORIES,
    tabsComponent: 'BrowseTab',
    shouldUseRetainedEvents: true,
    // SEO config
    titleKey: 'seo-explore-title',
    descriptionKey: 'seo-explore-description',
    keywordsKey: 'seo-explore-keywords',
    jsonLdType: 'ItemList',
    robots: ['noindex', 'nofollow'],
    shouldDisableSentrySpan: true,
  },
  livestream: {
    paths: ['/livestream'],
    categoriesRemoteConfigKey: HOME_LIVESTREAM_CATEGORIES,
    shouldUseRetainedEvents: true,
    // SEO config
    titleKey: 'seo_livestream_title',
    descriptionKey: 'seo_livestream_description',
    keywordsKey: 'seo_livestream_keywords',
    jsonLdType: 'ItemList',
  },
};

/**
 * Returns the configuration for the current home page based on the pathname.
 *
 * @param {object} [options] - An object containing the pathname.
 * @param {string} [options.pathname] - The pathname of the current page.
 * @returns {object} - The configuration for the current home page.
 */
export const getHomePageConfig = ({ pathname } = {}) => {
  // Remove language prefix from pathname for matching
  const cleanPath = removeLangFromPath(pathname);

  const key = Object.keys(HOME_PAGE_CONFIG).find(key =>
    HOME_PAGE_CONFIG[key].paths.includes(cleanPath)
  );
  return key ? HOME_PAGE_CONFIG[key] : {};
};
